import { useState, useEffect, forwardRef, useRef } from "react";
import "./style.css";
import {
  contractByBorrowType,
  contractByLoneType,
  fetchStockLoanKPI,
  isServiceHealthy,
} from "../../utils/API";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import withRefreshLoan from "../../redux/HOC/withRefreshLoan";
import withRefreshBorrow from "../../redux/HOC/withRefreshBorrow";
import withUser from "../../redux/HOC/withUser";
import { Modal } from "react-bootstrap";
import { Split } from "@geoffcox/react-splitter";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import _ from "lodash";
import { getTimeStamp, hasAccess } from "../../common/commonFunctions";
import {
  BASE_URI_SOCKET,
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import excel from "../../assets/images/excel.svg";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import BorrowGrid from "./Borrow";
import LoanGrid from "./Loan";
import { useNavigate } from "react-router";
import ContractActivity from "../../components/ContractActivity";
import Snackbar from "@mui/material/Snackbar";
import {
  constants,
  contractBrowserFilters,
  contractUpdateTitle,
  EndPoint,
  messages,
  socketMsgType,
} from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ContractMaintenance from "../../components/PCChange";
import swal from "sweetalert";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import UpdateContract from "../../components/UpdateContract";
import moment from "moment";
import ContractRecall from "../../components/ContractRecall";
import ContractReturn from "../../components/ContractReturn";
import { pageConstant, Permissions } from "../../config/pageConstant";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import Queue from "yocto-queue";

const Loan = ({ setRefreshBorrow, refreshBorrow, user }: any) => {
  //const socket = new SockJS(`${BASE_URI_CONTRACT_T4_SOCKET()}`);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const [insertBorrowRow, setInsertBorrowRow] = useState<any>([]);
  const [insertLoanRow, setInsertLoanRow] = useState<any>([]);
  const [insertedLoanRowIds, setInsertedLoanRowIds] = useState<any>([]);
  const [insertedBorrowRowIds, setInsertedBorrowRowIds] = useState<any>([]);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });
  const [socketToggle, setSocketToggle] = useState<any>(false);

  //const contract18Socket = new SockJS(`${BASE_URI_CONTRACT18_SOCKET()}`);
  //const contract18PendingSocket = new SockJS(`${BASE_URI_CONTRACT_UPDATE_PENDING_SOCKET()}`);
  //Contract

  // const dtcSocket = new SockJS(`${BASE_URI_DTC_SOCKET()}`);
  // Match Contract activity

  // const stompClient = Stomp.over(function () {
  //   return socket;
  // });

  //

  // const contract18StompClient = Stomp.over(function () {
  //   return contract18Socket;
  // });

  //Contracts
  // const contract18PendingClient = Stomp.over(function () {
  //   return contract18PendingSocket;
  // });

  // const dtcStompClient = Stomp.over(function () {
  //   return dtcSocket;
  // });

  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [open, setOpen] = useState(false);
  const queue = new Queue();

  // const [screenHeight, setScreenHeight] = useState(
  //   window.innerHeight ||
  //     document.documentElement.clientHeight ||
  //     document.body.clientHeight
  // );

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  function mergeRows(prevRows: any[], incomingRows: any[]) {
    const current = [...prevRows];

    const insertRows = _.differenceBy(incomingRows, prevRows, "contract_id");
    const updateRows = _.intersectionBy(
      [...incomingRows],
      [...prevRows],
      "contract_id"
    );

    updateRows.forEach((row) => {
      const idx = current.findIndex((c) => c.contract_id === row.contract_id);
      if (idx >= 0) {
        // merge instead of overwrite
        current[idx] = {
          ...current[idx],
          ...row,
          newValue: "",
          isSocketUpdate: true,
        };
      }
    });

    const finalRows = _.orderBy(
      [...insertRows, ...current],
      ["updatedDate"],
      ["desc"]
    );
    return { updatedRows: finalRows, insertedRows: insertRows };
  }

  useEffect(() => {
    // subscribe
    socketConsolidateClient.connect({}, () => {
      socketConsolidateClient.subscribe(
        "/topic/consolidated_message",
        (result: any) => {
          const resultJson = JSON.parse(result?.body);
          const records = resultJson?.socketMssgmap ?? [];
          queue.enqueue(records);
        }
      );
    });

    const interval = setInterval(() => {
      if (queue.size === 0) return;

      // drain queue completely
      const msgs: any[] = [];
      while (queue.size > 0) {
        msgs.push(queue.dequeue());
      }

      // merge all contracts + statuses
      const mergedContracts: any[] = [];
      const mergedStatuses: any[] = [];

      msgs.forEach((msg) => {
        mergedContracts.push(...(_.get(msg, socketMsgType.CONTRACT) || []));
        mergedStatuses.push(
          ...(_.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY) || [])
        );
      });

      if (mergedContracts.length > 0) {
        const socketRows = mergedContracts.map((item: any) => {
          const con = item?.messageJson;
          return {
            ...con,
            id: con?.contract_id + con?.contract_type?.toLowerCase(),
            updatedDate: new Date(con.update_date),
            updatedDateStr: getTimeStamp(con?.update_date),
            newValue: "",
            contractPrice:
              con?.contract_value &&
              con?.quantity &&
              con.quantity > 0 &&
              con?.contract_value / con?.quantity > 0
                ? parseFloat(
                    (con?.contract_value / con?.quantity).toString()
                  ).toFixed(2)
                : "",
            term_date:
              con.term_date && moment(con?.term_date)?.isValid()
                ? moment(con?.term_date).format(constants.Date_Format)
                : con.term_date,
          };
        });

        const borrowRows = socketRows.filter(
          (c) => c?.contract_type === "B" && c?.ui_status !== "Failed"
        );
        const loanRows = socketRows.filter(
          (c) => c?.contract_type === "L" && c?.ui_status !== "Failed"
        );

        // Borrow updates
        if (borrowRows.length > 0) {
          setBorrowRowData((prev) => {
            const { updatedRows, insertedRows } = mergeRows(prev, borrowRows);
            setInitialBorrowRowData(updatedRows);
            // if (insertedRows.length > 0) setInsertBorrowRow(insertedRows);
            return [...updatedRows];
          });
        }

        // Loan updates
        if (loanRows.length > 0) {
          setloanRowData((prev) => {
            const { updatedRows, insertedRows } = mergeRows(prev, loanRows);
            setInitialLoanRowData(updatedRows);
            if (insertedRows.length > 0) {
              // setInsertLoanRow(insertedRows);
              const ids = insertedRows.map((c) => c?.id);
              setInsertedLoanRowIds(ids.length > 0 ? [ids] : []);
            }
            return updatedRows;
          });
        }
      }

      if (mergedStatuses.length > 0) {
        const socketRows = mergedStatuses.map((item: any) => ({
          ...item,
          id: item?.contract_id + item?.bl?.toLowerCase(),
        }));

        const bRows = socketRows.filter((c) => c?.bl === "B");
        const lRows = socketRows.filter((c) => c?.bl === "L");

        if (bRows.length > 0) updateDTCStatusBorrowGrid(bRows);
        if (lRows.length > 0) updateDTCStatusLoanGrid(lRows);
      }
    }, 100); // process every 100ms

    return () => {
      clearInterval(interval);
      try {
        if (socketConsolidateClient?.connected) {
          socketConsolidateClient.unsubscribe("/topic/consolidated_message");
          socketConsolidateClient.disconnect();
        }
      } catch {}
      queue.clear();
    };
  }, []);


  const onSocketMsgReceive = async (msg: any) => {
    const contractList = _.get(msg, socketMsgType.CONTRACT);
    const dtcStatusList = _.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY);
    if (_.isArray(contractList) && !_.isEmpty(contractList)) {
      let socketRows = [...contractList]?.map((item: any) => {
        let con = item?.messageJson;
        return {
          ...con,
          id: con?.contract_id + con?.contract_type?.toLowerCase(),
          updatedDate: new Date(con.update_date),
          updatedDateStr: getTimeStamp(con?.update_date),
          newValue: "",
          contractPrice:
            con?.contract_value &&
            con?.quantity &&
            con.quantity > 0 &&
            con?.contract_value / con?.quantity > 0
              ? parseFloat(
                  (con?.contract_value / con?.quantity).toString()
                ).toFixed(2)
              : "",
          term_date:
            con.term_date &&
            moment(con?.term_date) &&
            moment(con?.term_date).isValid()
              ? moment(con?.term_date).format(constants.Date_Format)
              : con.term_date,
        };
      });

      const borrowRows = [...socketRows]?.filter(
        (c: any) => c?.contract_type === "B" && c?.ui_status !== "Failed"
      );

      const loanRows = [...socketRows]?.filter(
        (c: any) => c?.contract_type === "L" && c?.ui_status !== "Failed"
      );

      setBorrowRowData((previousRows: any[]) => {
        const currentRows = [...previousRows];
        const insertRows = _.differenceBy(
          borrowRows,
          previousRows,
          "contract_id"
        );
        const updateRows = _.intersectionBy(
          borrowRows,
          previousRows,
          "contract_id"
        );

        if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
          setInsertBorrowRow(insertRows);
          // const ids = insertRows?.map((c) => {
          //   return c?.id;
          // });
          // setInsertedBorrowRowIds(ids?.length > 0 ? [ids] : []);
        }

        updateRows?.forEach((row: any) => {
          const index = currentRows?.findIndex(
            (c: any) => c.contract_id === row?.contract_id
          );
          if (index >= 0) {
            row.newValue = "";
            currentRows[index] = row;
          }
        });

        let sortedRows = _.orderBy(currentRows, ["updatedDate"], ["desc"]);
        return sortedRows;
      });

      setInitialBorrowRowData((previousRows: any[]) => {
        const currentRows = [...previousRows];
        const insertRows = _.differenceBy(
          borrowRows,
          previousRows,
          "contract_id"
        );
        const updateRows = _.intersectionBy(
          borrowRows,
          previousRows,
          "contract_id"
        );

        if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
          setInsertBorrowRow(insertRows);
          // const ids = insertRows?.map((c) => {
          //   return c?.id;
          // });
          // setInsertedBorrowRowIds(ids?.length > 0 ? [ids] : []);
        }

        updateRows?.forEach((row: any) => {
          const index = currentRows?.findIndex(
            (c: any) => c.contract_id === row?.contract_id
          );
          if (index >= 0) {
            row.newValue = "";
            currentRows[index] = row;
          }
        });

        let sortedRows = _.orderBy(currentRows, ["updatedDate"], ["desc"]);
        return sortedRows;
      });

      setloanRowData((previousRows: any[]) => {
        const currentRows = [...previousRows];
        const insertRows = _.differenceBy(
          loanRows,
          previousRows,
          "contract_id"
        );
        const updateRows = _.intersectionBy(
          loanRows,
          previousRows,
          "contract_id"
        );

        if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
          setInsertLoanRow(insertRows);
          const ids = insertRows?.map((c) => {
            return c?.id;
          });
          setInsertedLoanRowIds(ids?.length > 0 ? [ids] : []);
        }

        updateRows?.forEach((row: any) => {
          const index = currentRows?.findIndex(
            (c: any) => c.contract_id === row?.contract_id
          );
          if (index >= 0) {
            row.newValue = "";
            currentRows[index] = row;
          }
        });

        let sortedRows = _.orderBy(currentRows, ["updatedDate"], ["desc"]);
        return sortedRows;
      });

      setInitialLoanRowData((previousRows: any[]) => {
        const currentRows = [...previousRows];
        const insertRows = _.differenceBy(
          loanRows,
          previousRows,
          "contract_id"
        );
        const updateRows = _.intersectionBy(
          loanRows,
          previousRows,
          "contract_id"
        );

        if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
          setInsertLoanRow(insertRows);
          const ids = insertRows?.map((c) => {
            return c?.id;
          });
          setInsertedLoanRowIds(ids?.length > 0 ? [ids] : []);
        }

        updateRows?.forEach((row: any) => {
          const index = currentRows?.findIndex(
            (c: any) => c.contract_id === row?.contract_id
          );
          if (index >= 0) {
            row.newValue = "";
            currentRows[index] = row;
          }
        });

        let sortedRows = _.orderBy(currentRows, ["updatedDate"], ["desc"]);
        return sortedRows;
      });
    }
    if (_.isArray(dtcStatusList) && !_.isEmpty(dtcStatusList)) {
      let socketRows = [...dtcStatusList]?.map((item: any) => {
        return { ...item, id: item?.contract_id + item?.bl?.toLowerCase() };
      });

      const bRows = socketRows?.filter((c: any) => c?.bl === "B");
      const lRows = socketRows?.filter((c: any) => c?.bl === "L");
      if (_.isArray(bRows)) {
        updateDTCStatusBorrowGrid(bRows);
      }
      if (lRows) {
        updateDTCStatusLoanGrid(lRows);
      }
    }

    //   setTimeout(() => {
    //     queue?.dequeue()
    //  }, 1000);
  };

  useEffect(() => {
    if (
      insertBorrowRow &&
      _.isArray(insertBorrowRow) &&
      !_.isEmpty(insertBorrowRow)
    ) {
      setBorrowRowData((previousRows) => {
        const currentRows = [...insertBorrowRow, ...previousRows];
        const uniqRows = _.uniqBy(currentRows, "contract_id");

        return uniqRows;
      });

      setInitialBorrowRowData((previousRows) => {
        const currentRows = [...insertBorrowRow, ...previousRows];
        const uniqRows = _.uniqBy(currentRows, "contract_id");

        return uniqRows;
      });
    }
  }, [insertBorrowRow]);

  useEffect(() => {
    if (
      insertLoanRow &&
      _.isArray(insertLoanRow) &&
      !_.isEmpty(insertLoanRow)
    ) {
      setloanRowData((previousRows) => {
        const currentRows = [...insertLoanRow, ...previousRows];
        const uniqueRows = _.uniqBy(currentRows, "contract_id");

        return uniqueRows;
      });

      setInitialLoanRowData((previousRows) => {
        const currentRows = [...insertLoanRow, ...previousRows];
        const uniqueRows = _.uniqBy(currentRows, "contract_id");

        return uniqueRows;
      });
    }
  }, [insertLoanRow]);

  const updateDTCStatusBorrowGrid = async (trades: any[]) => {
    await setBorrowRowData((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.id === trade?.contract_id + "b"
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
              return currentRows;
            }
          });
        }
      }
      return previousRows;
    });

    await setInitialBorrowRowData((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.id === trade?.contract_id + "b"
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
              return currentRows;
            }
          });
        }
      }
      return previousRows;
    });
  };

  const updateDTCStatusLoanGrid = async (trades: any) => {
    setloanRowData((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.id === trade?.contract_id + "l"
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
              return currentRows;
            }
          });
        }
      }
      return previousRows;
    });

    setInitialLoanRowData((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.id === trade?.contract_id + "l"
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
              return currentRows;
            }
          });
        }
      }
      return previousRows;
    });
  };

  useEffect(() => {
    getServiceHealthCheck();
  }, []);

  const [borrowRowData, setBorrowRowData] = useState<Array<any>>([]);
  const [loanRowData, setloanRowData] = useState<Array<any>>([]);
  const [initialBorrowRowData, setInitialBorrowRowData] = useState<Array<any>>(
    []
  );
  const [initialLoanRowData, setInitialLoanRowData] = useState<Array<any>>([]);
  const [isAnyPending, setIsAnyPending] = useState<boolean>(false);

  const [heightAG_1] = useState(35);
  const [refData, setRefData] = useState<any>(null);
  const [refDataNew, setRefDataNew] = useState<any>(null);
  const [gridApiLoan, setGridApiLoan] = useState<any>(null);
  const [gridApiBorrow, setGridApiBorrow] = useState<any>(null);
  const [stockLoanKPI, setStockLoanKPI] = useState<any>([]);
  const [isContractActivityPopupOpened, setIsContractActivityPopupOpened] =
    useState<boolean>(false);
  const [contractId, setContractId] = useState<any>(null);
  const [contractType, setContractType] = useState<any>(null);
  const [
    isContractMaintenanceChangePopup,
    setIsContractMaintenanceChangePopup,
  ] = useState<boolean>(false);
  const [selectedBorrowRows, setSelectedBorrowRows] = useState<any>([]);
  const [selectedLoanRows, setSelectedLoanRows] = useState<any>([]);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [contractMaintenanceType, setContractMaintenanceType] =
    useState<any>(null);

  const [updateContractTitle, setUpdateContractTitle] = useState<any>("");
  const [isDeselectAll, setIsDeselectAll] = useState<boolean>(false);
  const [isUpdateGridCell, setIsUpdateGridCell] = useState<boolean>(false);
  const [updatedRowIds, setUpdatedRowIds] = useState<any[]>([]);
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [isContractUpdatePopupOpen, setIsContractUpdatePopupOpen] =
    useState<boolean>(false);
  const [totalRows, setTotalRows] = useState<any[]>([]);
  const [isContractRecallPopUpOpen, setContractRecallPopupOpen] =
    useState<boolean>(false);
  const [isContractReturnPopUpOpen, setContractReturnPopupOpen] =
    useState<boolean>(false);
  const [externalFilters, setExternalFilters] = useState<any>({
    isRecallFilterActive: false,
    isBuyInFilterActive: false,
  });
  const refreshBorrowsAndLoans = () => {
    setBorrowRowData([]);
    setloanRowData([]);
    if (queue) queue?.clear();
    getBorrowsAndLoans();
  };
  const getBorrowsAndLoans = async () => {
    let contractByBorrowTypeRes: any = "";
    let contractByLoneTypeRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    let accountCode = window.localStorage.getItem("activeAccountCode");
    try {
      contractByBorrowTypeRes = await contractByBorrowType(
        user.tokenType,
        accessToken,
        accountCode
      );
      if (!contractByBorrowTypeRes) {
        setOpen(true);
        setSnackbarMessage(messages.loanetServiceDown);
      }
      if (contractByBorrowTypeRes.status === 200) {
        const borrowRows = await contractByBorrowTypeRes.json();
        if (borrowRows && !_.isEmpty(borrowRows)) {
          let rows = borrowRows.map((r: any) => ({
            ...r,
            id: r?.contract_id + "b",
            updatedDate: new Date(r.update_date),
            updatedDateStr: getTimeStamp(r?.update_date),
            newValue: "",
            contractPrice:
              r?.contract_value &&
              r?.quantity &&
              r.quantity > 0 &&
              r?.contract_value / r?.quantity > 0
                ? parseFloat(
                    (r?.contract_value / r?.quantity).toString()
                  ).toFixed(2)
                : "",
            term_date:
              r.term_date &&
              moment(r?.term_date) &&
              moment(r?.term_date).isValid()
                ? moment(r?.term_date).format(constants.Date_Format)
                : r.term_date,
          }));

          let sortedRows = _.orderBy(rows, ["updatedDate"], ["desc"]);
          setBorrowRowData(sortedRows);
          setInitialBorrowRowData(sortedRows);
          if (queue) queue?.clear();
        }
        queue?.clear();
      } else if (contractByBorrowTypeRes?.status === 401) {
        navigate("/signin");
      } else {
        setBorrowRowData([]);
      }
    } catch (err) {
      setBorrowRowData([]);
    }

    try {
      contractByLoneTypeRes = await contractByLoneType(
        user.tokenType,
        accessToken,
        accountCode
      );
      if (!contractByLoneTypeRes) {
        setOpen(true);
        setSnackbarMessage(messages.loanetServiceDown);
      }
      if (contractByLoneTypeRes.status === 200) {
        let loanRows = await contractByLoneTypeRes.json();
        if (loanRows && !_.isEmpty(loanRows)) {
          let rows = loanRows.map((r: any) => ({
            ...r,
            id: r?.contract_id + "l",
            updatedDate: new Date(r.update_date),
            updatedDateStr: getTimeStamp(r?.update_date),
            newValue: "",
            contractPrice:
              r?.contract_value &&
              r?.quantity &&
              r.quantity > 0 &&
              r?.contract_value / r?.quantity > 0
                ? parseFloat(
                    (r?.contract_value / r?.quantity).toString()
                  ).toFixed(2)
                : "",
            term_date:
              r.term_date &&
              moment(r?.term_date) &&
              moment(r?.term_date).isValid()
                ? moment(r?.term_date).format(constants.Date_Format)
                : r.term_date,
          }));
          let sortedRows = _.orderBy(rows, ["updatedDate"], ["desc"]);
          setloanRowData(sortedRows);
          setInitialLoanRowData(sortedRows);
        }
        queue?.clear();
      } else if (contractByBorrowTypeRes?.status === 401) {
        navigate("/signin");
      } else {
        setloanRowData([]);
      }
    } catch (err) {
      setloanRowData([]);
    }
  };

  const onContractMaintenanceChangePopup = () => {
    if (selectedRows && !_.isEmpty(selectedRows)) {
      let rows = selectedRows.map((r: any) => ({
        ...r,
        newValue: "",
      }));

      setSelectedRows(rows);
    }
    setIsContractMaintenanceChangePopup(true);
  };

  const getStockLoanKPI = async () => {
    let fetchStockLoanKPIRes: any = "";
    let fetchStockLoanKPIData: any = "";
    var accessToken = window.localStorage.getItem("refreshtoken");
    let accountCode = window.localStorage.getItem("activeAccountCode");
    if (accessToken && accountCode) {
      try {
        fetchStockLoanKPIRes = await fetchStockLoanKPI(
          user.tokenType,
          accessToken,
          accountCode
        );
        if (!fetchStockLoanKPIRes) {
          setOpen(true);
          setSnackbarMessage(messages.loanetServiceDown);
        } else if (fetchStockLoanKPIRes?.status === 200) {
          fetchStockLoanKPIData = await fetchStockLoanKPIRes?.json();
          setStockLoanKPI(fetchStockLoanKPIData);
        } else if (fetchStockLoanKPIRes.status === 401) {
          navigate("/signin");
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    let CurrentDateforRefresh: any = new Date();
    setRefreshBorrow(
      CurrentDateforRefresh.toLocaleString("en-US", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );
    const isPending =
      _.some(borrowRowData, ["processing_status", "Pending"]) ||
      _.some(loanRowData, ["processing_status", "Pending"]);
    setIsAnyPending(isPending);
    setTotalRows((previousRows: any) => {
      previousRows = [...borrowRowData, ...loanRowData];
      let rows = previousRows?.map((r: any) => ({
        ...r,
        newValue: "",
      }));
      return rows;
    });
  }, [borrowRowData, loanRowData]);

  const onFilterTextChange = _.debounce((e: any) => {
    let filterDataLoan: any = refData?.current?.api?.setQuickFilter(
      e.target.value
    );
    refDataNew?.current?.api?.setQuickFilter(e.target.value);
    refData?.current?.api?.applyTransaction({
      update: filterDataLoan,
    });
  }, 800);

  const openContractActivityGrid = async (params: any) => {
    setContractId(params.contract_id);
    setContractType(params.contract_type);
  };

  useEffect(() => {
    if (contractId && contractType) setIsContractActivityPopupOpened(true);
  }, [contractId, contractType]);

  const updateContractFromGrid = (row: any, cmType: string) => {
    setSelectedRows((previousRows: any) => {
      if (_.isEmpty(previousRows)) {
        return [row];
      }
      return previousRows;
    });

    setContractMaintenanceType(cmType);
    onContractMaintenanceChangePopup();
  };

  const updateContractsFromContextMenu = (row: any) => {
    setSelectedRows((previousRows: any) => {
      if (_.isEmpty(previousRows)) {
        return [row];
      }
      return previousRows;
    });
    setIsContractUpdatePopupOpen(true);
  };

  const recallContractFromConextMenu = (row: any) => {
    const isBorrowRowsExists = selectedBorrowRows?.length > 0;
    if (isBorrowRowsExists) {
      swal({
        icon: "warning",
        text: "Please un select the borrow contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      setSelectedRows((previousRows: any) => {
        if (_.isEmpty(previousRows)) {
          return [row];
        }
        return previousRows;
      });
      setContractMaintenanceType(constants.RECALL);
      setContractRecallPopupOpen(true);
    }
  };

  const returnContractFromConextMenu = (row: any) => {
    const isLoanRowsExists = selectedLoanRows?.length > 0;
    if (isLoanRowsExists) {
      swal({
        icon: "warning",
        text: "Please un select the loan contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      setSelectedRows((previousRows: any) => {
        if (_.isEmpty(previousRows)) {
          return [row];
        }
        return previousRows;
      });
      setContractMaintenanceType(constants.RETURN);
      setContractReturnPopupOpen(true);
    }
  };

  // useEffect(() => {
  //   const returnInterval: any = setInterval(() => {
  //     getBorrowsAndLoans();
  //   }, 5000);
  //   return () => clearInterval(returnInterval);
  // }, []);

  const getContextMenuItemsBorrows = (params: any) => {
    var rightClickOptionsWithRWAccess = [
      {
        name: "Contract Activity",
        action: () => {
          openContractActivityGrid(params.node.data);
        },
      },
      {
        name: "PC Change",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.profitCenter);
          updateContractFromGrid(params?.node?.data, constants.PROFIT_CENTER);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Rebate Rate",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.rateChange);
          updateContractFromGrid(params.node.data, constants.REBATE_RATE);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Mark to Mark",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.markToMark);
          updateContractFromGrid(params.node.data, constants.MARK_TO_MARKET);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Update",
        action: () => {
          updateContractsFromContextMenu(params?.node?.data);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Return",
        action: () => {
          returnContractFromConextMenu(params?.node?.data);
        },
        disabled:
          params?.node?.data?.processing_status === "Pending" ||
          params?.node?.data?.quantity <= 0,
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];

    var rightClickOptionsROnlyAccess = [
      {
        name: "Contract Activity",
        action: () => {
          openContractActivityGrid(params.node.data);
        },
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];

    return params?.node?.data
      ? hasAccess([
          `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.ReadWrite}`,
          `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.Admin}`,
        ])
        ? rightClickOptionsWithRWAccess
        : rightClickOptionsROnlyAccess
      : [];
  };

  const getContextMenuItemsLoans = (params: any) => {
    var rightClickOptionsWithRWAccess = [
      {
        name: "Contract Activity",
        action: () => {
          openContractActivityGrid(params.node.data);
        },
      },
      {
        name: "PC Change",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.profitCenter);
          updateContractFromGrid(params?.node?.data, constants.PROFIT_CENTER);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Rebate Rate",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.rateChange);
          updateContractFromGrid(params.node.data, constants.REBATE_RATE);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Mark to Mark",
        action: () => {
          setUpdateContractTitle(contractUpdateTitle.markToMark);
          updateContractFromGrid(params.node.data, constants.MARK_TO_MARKET);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Update",
        action: () => {
          updateContractsFromContextMenu(params?.node?.data);
        },
        disabled: params?.node?.data?.processing_status === "Pending",
      },
      {
        name: "Recall",
        action: () => {
          recallContractFromConextMenu(params?.node?.data);
        },
        disabled:
          params?.node?.data?.processing_status === "Pending" ||
          params?.node?.data?.quantity -
            params?.node?.data?.total_recall_quantity <=
            0,
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];

    var rightClickOptionsROnlyAccess = [
      {
        name: "Contract Activity",
        action: () => {
          openContractActivityGrid(params.node.data);
        },
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];

    return params?.node?.data
      ? hasAccess([
          `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.ReadWrite}`,
          `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.Admin}`,
        ])
        ? rightClickOptionsWithRWAccess
        : rightClickOptionsROnlyAccess
      : [];
  };

  const getGridsHeight = () => {
    let offsetHeight = document?.getElementById(
      "contractBrowserTitleDiv"
    )?.offsetHeight;
    return "calc(100% - " + (offsetHeight ? offsetHeight + 10 : 0) + "px)";
  };

  function onExcelExport() {
    var spreadsheets = [];

    spreadsheets.push(
      gridApiBorrow?.getSheetDataForExcel?.({ sheetName: "Borrows" })!,
      gridApiLoan?.getSheetDataForExcel?.({ sheetName: "Loans" })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "contract-browser.xlsx",
    });
  }

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }
    setOpen(false);
  };

  const handleCMPopupClose = () => {
    setIsContractMaintenanceChangePopup(false);
    handleContractMainClose();
  };

  const handleContractMainClose = () => {
    setSelectedRows([]);
    setIsDeselectAll(true);
    setTimeout(() => {
      setIsDeselectAll(false);
    }, 500);
  };

  const handleContractUpdatePopupClose = () => {
    setIsContractUpdatePopupOpen(false);
    handleContractMainClose();
  };

  const handleContractRecallClose = () => {
    handleContractMainClose();
    setContractRecallPopupOpen(false);
  };

  const handleContractReturnClose = () => {
    handleContractMainClose();
    setContractReturnPopupOpen(false);
  };

  const onContractMaintenanceChange = (type: string) => {
    if (type !== constants.ADMIN_RATE && selectedRows?.length === 0) {
      swal({
        icon: "warning",
        text: "Please select contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      setContractMaintenanceType(type);
      switch (type) {
        case constants.PROFIT_CENTER:
          setUpdateContractTitle(contractUpdateTitle.profitCenter);
          break;
        case constants.REBATE_RATE:
          setUpdateContractTitle(contractUpdateTitle.rateChange);
          break;
        case constants.MARK_TO_MARKET:
          setUpdateContractTitle(contractUpdateTitle.markToMark);
          break;
        case constants.ADMIN_RATE:
          setSelectedRows([...borrowRowData, ...loanRowData]);
          setUpdateContractTitle(contractUpdateTitle.adminRate);
          break;
      }
      onContractMaintenanceChangePopup();
    }
  };

  const onContractUpdate = () => {
    if (selectedRows?.length === 0) {
      swal({
        icon: "warning",
        text: "Please select contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      setIsContractUpdatePopupOpen(true);
    }
  };

  useEffect(() => {
    setSelectedRows(() => {
      return [...selectedBorrowRows, ...selectedLoanRows];
    });
  }, [selectedBorrowRows, selectedLoanRows]);

  useEffect(() => {
    if (isUpdateGridCell) {
      setIsUpdateGridCell(false);
    }
  }, [isUpdateGridCell]);

  const updateGrid = (rows: any, previousRows: any) => {
    try {
      if (_.isArray(rows) && rows?.length > 0) {
        rows?.forEach((row: any) => {
          const changedValue = row?.changes[0]?.value;

          let index = previousRows?.findIndex(
            (r: any) =>
              r?.contract_id === row?.contractId ||
              r?.contract_id === row?.contract_id
          );

          if (index !== -1) {
            previousRows[index].processing_status = previousRows[index]
              .isSocketUpdate
              ? previousRows[index].processing_status
              : "Pending";
            if (contractMaintenanceType === constants?.PROFIT_CENTER) {
              previousRows[index].isPCUpdated = true;
              previousRows[index].profit_center =
                changedValue && !_.isEmpty(changedValue)
                  ? changedValue
                  : previousRows[index].profit_center;
            } else if (
              contractMaintenanceType === constants?.REBATE_RATE ||
              contractMaintenanceType === constants?.ADMIN_RATE
            ) {
              previousRows[index].isRateUpdated = true;
              previousRows[index].rate = _.isNaN(changedValue)
                ? previousRows[index].rate
                : parseFloat(changedValue);
            } else if (contractMaintenanceType === constants?.MARK_TO_MARKET) {
              previousRows[index].isMarkToMarkUpdated = true;
              previousRows[index].contractPrice = row?.contractPrice;
              previousRows[index].contract_value = changedValue;
            } else if (contractMaintenanceType === constants?.RETURN) {
              previousRows[index].isReturnUpdated = true;
              previousRows[index].quantity =
                previousRows[index].quantity - changedValue;
            }
            gridApiBorrow?.refreshCells();
          }
        });
      }
    } catch (err) {
    } finally {
      return previousRows;
    }
  };

  const updateGridCells = (rows: any) => {
    setBorrowRowData((prev) => {
      const bRows = rows?.filter(
        (r: any) =>
          r?.bl?.toLowerCase() === "b" ||
          r?.contract_type?.toLowerCase() === "b"
      );
      const updatedRows = updateGrid(bRows, prev);
      setInitialBorrowRowData(updatedRows);
      return [...updatedRows];
    });

    setloanRowData((prev) => {
      const lRows = rows?.filter(
        (r: any) =>
          r?.bl?.toLowerCase() === "l" ||
          r?.contract_type?.toLowerCase() === "l"
      );
      const updatedRows = updateGrid(lRows, prev);
      setInitialLoanRowData(updatedRows);
      return [...updatedRows];
    });

    handleCMPopupClose();
  };


  useEffect(() => {
    const returnInterval = setInterval(() => {
      getStockLoanKPI();
    }, 5000);
    return () => clearInterval(returnInterval);
  }, []);

  const onContractRecall = () => {
    if (selectedRows?.length === 0) {
      swal({
        icon: "warning",
        text: "Please select contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      const zeroQtyRows = selectedLoanRows?.filter(
        (x: any) => x.quantity - x.total_recall_quantity <= 0
      );
      if (zeroQtyRows && zeroQtyRows?.length > 0) {
        swal({
          icon: "warning",
          text: "Please un select the fully recalled contract(s)",
          dangerMode: false,
          closeOnClickOutside: false,
        });
      } else {
        setSelectedLoanRows((previousRows: any) => {
          const currentRows = previousRows?.map((loan: any) => {
            return {
              ...loan,
              newValue: "",
            };
          });

          return currentRows;
        });
        setContractMaintenanceType(constants.RECALL);
        setContractRecallPopupOpen(true);
      }
    }
  };

  const onContractReturn = () => {
    if (selectedRows?.length === 0) {
      swal({
        icon: "warning",
        text: "Please select contract(s)",
        dangerMode: false,
        closeOnClickOutside: false,
      });
    } else {
      const zeroQtyRows = selectedBorrowRows?.filter(
        (x: any) => x.quantity <= 0
      );
      if (zeroQtyRows && zeroQtyRows?.length > 0) {
        swal({
          icon: "warning",
          text: "Please un select the fully returned contract(s)",
          dangerMode: false,
          closeOnClickOutside: false,
        });
      } else {
        setContractMaintenanceType(constants.RETURN);
        setContractReturnPopupOpen(true);
      }
    }
  };

  const isDisableReturn = () => {
    return selectedLoanRows?.length > 0;
  };

  const hasContractActivityWritable = () => {
    return hasAccess([
      `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.ReadWrite}`,
      `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.Admin}`,
    ]);
  };

  useEffect(() => {
    let rows = [...initialLoanRowData];
    if (externalFilters && !_.isEmpty(rows)) {
      if (!_.isEmpty(rows)) {
        if (
          externalFilters.isRecallFilterActive &&
          externalFilters.isBuyInFilterActive
        ) {
          rows = filterRows(contractBrowserFilters.recall, rows);
          rows = filterRows(contractBrowserFilters.buy_in, rows);
        } else {
          if (externalFilters.isRecallFilterActive)
            rows = filterRows(contractBrowserFilters.recall, rows);
          else if (externalFilters.isBuyInFilterActive)
            rows = filterRows(contractBrowserFilters.buy_in, rows);
        }
      }
    }
    setloanRowData(rows);
  }, [externalFilters, initialLoanRowData]);

  useEffect(() => {
    let rows = [...initialBorrowRowData];
    if (externalFilters && !_.isEmpty(rows)) {
      if (!_.isEmpty(rows)) {
        if (
          externalFilters.isRecallFilterActive &&
          externalFilters.isBuyInFilterActive
        ) {
          rows = filterRows(contractBrowserFilters.recall, rows);
          rows = filterRows(contractBrowserFilters.buy_in, rows);
        } else {
          if (externalFilters.isRecallFilterActive)
            rows = filterRows(contractBrowserFilters.recall, rows);
          else if (externalFilters.isBuyInFilterActive)
            rows = filterRows(contractBrowserFilters.buy_in, rows);
        }
      }
    }
    setBorrowRowData(rows);
  }, [externalFilters, initialBorrowRowData]);

  const filterRows = (filter: any, rows: any) => {
    switch (filter) {
      case contractBrowserFilters.buy_in:
        return rows?.filter((x: any) => x.is_buyin === "Y");
      case contractBrowserFilters.recall:
        return rows?.filter((x: any) => x.recall === "Y");
    }
    return rows;
  };

  const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["LOANETCONTRACT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`${messages.loanetServiceDown}`);
        setOpen(true);
      } else {
        getStockLoanKPI();
        getBorrowsAndLoans();
      }
    });
  };

  return (
    <>
      {doShowFullScreenLoader && <SpinnerFullScreen></SpinnerFullScreen>}
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#EAECEF",
          overflow: "hidden",
        }}
        className="mx-auto"
      >
        <Modal
          size="lg"
          centered
          show={isContractActivityPopupOpened}
          onHide={() => {
            setSocketToggle(!socketToggle);
            setIsContractActivityPopupOpened(false);
          }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>
              Contract Activity ({contractId}/{contractType})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContractActivity
              contractId={contractId}
              contractType={contractType}
            ></ContractActivity>
          </Modal.Body>
        </Modal>
        <div id="contractBrowserTitleDiv" className="row w-100 mx-auto">
          <div className="col p-0  w-100">
            <div className="row title-subHeaderTitle contract-browser-title">
              <div className="col ">Contract Browser</div>
            </div>

            <div className="mx-auto row">
              <div className="col">
                <div className="logo-HeaderPart">
                  {stockLoanKPI.map((item: any, index: any) => {
                    return (
                      <div className="borrow-ticket col" key={index}>
                        <div className="loanHeader-title text-nowrap">{item.kpiName}</div>
                        <div className="loanHeader-price text-nowrap">
                          {item.kpiName === "Imbalance-BOX" ? (
                            <span
                              style={{
                                color: item.kpiValue?.includes("-")
                                  ? "#E90909"
                                  : "#039000",
                              }}
                            >
                              {item.kpiValue}
                            </span>
                          ) : item.kpiName === "CASH-Excess-Deficit" ||
                            item.kpiName === "Total-Excess-Deficit" ||
                            item.kpiName === "PNL" ? (
                            <span
                              style={{
                                color: item.kpiValue.includes("-")
                                  ? "#E90909"
                                  : "#039000",
                              }}
                            >
                              {item.kpiValue}
                            </span>
                          ) : (
                            <span style={{ color: "#1E355E" }}>
                              {item.kpiValue}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="row w-100 mt-1 mx-auto flex-wrap flex-column flex-md-row">
              {/* Search Box */}
              <div className="col-12 col-md-4 mb-1 d-flex justify-content-start">
                <div className="globalfilterdiv globalSearch-globalFilter d-flex align-items-center ms-0">
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box"
                    onInput={onFilterTextChange}
                    className="form-control"
                  />
                  <SearchIcon
                    style={{
                      fontSize: "1rem",
                      color: "#1e355e",
                      marginLeft: "0.5rem",
                    }}
                  />
                </div>
              </div>

              {/* Filters & Buttons */}
              <div className="col-12 col-md-8 p-0 mx-auto d-flex flex-column flex-md-row justify-content-md-end gap-1">
                <div className="d-flex flex-wrap gap-1 align-items-center justify-content-center justify-content-md-end">
                  <div className="button-scroll-wrapper d-md-flex flex-nowrap gap-2 metrics-div me-1">
                    {/* Checkboxes */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="py-0 "
                          onChange={() => {
                            setExternalFilters((filters: any) => ({
                              ...filters,
                              isBuyInFilterActive:
                                !filters?.isBuyInFilterActive,
                            }));
                          }}
                        />
                      }
                      label={<Typography>Is-BuyIn</Typography>}
                      className="pe-2 py-0 me-1"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          className="py-0"
                          onChange={() => {
                            setExternalFilters((filters: any) => ({
                              ...filters,
                              isRecallFilterActive:
                                !filters?.isRecallFilterActive,
                            }));
                          }}
                        />
                      }
                      label={<Typography>Is-Recall</Typography>}
                      className="pe-2 py-0 me-1"
                    />

                    {/* Buttons */}
                    <button
                      type="button"
                      onClick={() =>
                        onContractMaintenanceChange(constants.PROFIT_CENTER)
                      }
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={!hasContractActivityWritable()}
                    >
                      PC Change
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        onContractMaintenanceChange(constants.REBATE_RATE)
                      }
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={!hasContractActivityWritable()}
                    >
                      Rebate Rate
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        onContractMaintenanceChange(constants.MARK_TO_MARKET)
                      }
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={!hasContractActivityWritable()}
                    >
                      Mark to Market
                    </button>

                    <button
                      type="button"
                      onClick={onContractUpdate}
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      title="Update Mark/Div/Term Date"
                      disabled={!hasContractActivityWritable()}
                    >
                      Update
                    </button>

                    <button
                      type="button"
                      onClick={onContractRecall}
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={
                        !hasContractActivityWritable() ||
                        selectedBorrowRows?.length > 0
                      }
                    >
                      Recall
                    </button>

                    <button
                      type="button"
                      onClick={onContractReturn}
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={
                        !hasContractActivityWritable() || isDisableReturn()
                      }
                    >
                      Return
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        onContractMaintenanceChange(constants.ADMIN_RATE)
                      }
                      className="btn btn-primary btn-xs border-radius-6 cb-button  px-2"
                      disabled={
                        !hasAccess([
                          `${pageConstant.CONTRACT_ACTIVITY}_${Permissions.Admin}`,
                        ]) || isAnyPending
                      }
                    >
                      Rerate the Book
                    </button>
                  </div>

                  {/* Excel Download & Refresh */}
                  <div className="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center gap-2">
                    <div
                      className="borrowExceldnld"
                      onClick={onExcelExport}
                      title="Download Excel"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={excel}
                        alt="Excel"
                        style={{ height: "1.8rem", width: "1.8rem" }}
                      />
                    </div>

                    <div
                      onClick={refreshBorrowsAndLoans}
                      title="Refresh Data"
                      className="refreshiconContract d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      <RefreshIcon
                        style={{
                          color: "#1E355E",
                          marginRight: "0.5rem",
                          height: "1.5rem",
                          width: "1.5rem",
                        }}
                      />
                      <div className="refreshsettimedateContract">
                        <div>Last updated on: </div>
                        <div>{refreshBorrow}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="row mt-1 mx-auto"
          style={{ width: "100%", height: getGridsHeight() }}
        >
          <Split horizontal>
            <div style={{ height: "100%" }}>
              <BorrowGrid
                rowData={borrowRowData}
                insertRowId={insertedBorrowRowIds}
                getContextMenuItems={getContextMenuItemsBorrows}
                nonSelectableRowIds={updatedRowIds}
                height={heightAG_1}
                type="borrow"
                title="Borrows"
                getBtnRef={(gridRef: any) => {
                  setRefData(gridRef);
                }}
                getGridApi={(gridApi: any, gridColumnApi: any) => {
                  setGridApiBorrow(gridApi);
                }}
                setSelectedRows={(rows: any) => {
                  setSelectedBorrowRows(rows);
                }}
                isDeselectAll={isDeselectAll}
              />
            </div>
            <div style={{ height: "100%" }}>
              <LoanGrid
                rowData={loanRowData}
                insertRowId={insertedLoanRowIds}
                nonSelectableRowIds={updatedRowIds}
                height={heightAG_1}
                type="loan"
                title="Loans"
                getContextMenuItems={getContextMenuItemsLoans}
                getBtnRef={(gridRef: any) => {
                  setRefDataNew(gridRef);
                }}
                getGridApi={(gridApi: any, gridColumnApi: any) => {
                  setGridApiLoan(gridApi);
                }}
                setSelectedRows={(rows: any) => {
                  setSelectedLoanRows(rows);
                }}
                isDeselectAll={isDeselectAll}
              />
            </div>
          </Split>
        </div>
      </div>

      <div>
        <Modal
          size="xl"
          centered
          show={isContractMaintenanceChangePopup}
          onHide={() => {
            handleCMPopupClose();
          }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>{updateContractTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContractMaintenance
              cmType={contractMaintenanceType}
              selectedRows={
                contractMaintenanceType === constants?.ADMIN_RATE
                  ? totalRows
                  : selectedRows
              }
              updateGridCells={updateGridCells}
              handleCMPopupClose={handleCMPopupClose}
              setUpdatedRowIds={setUpdatedRowIds}
              setDoShowFullScreenLoader={setDoShowFullScreenLoader}
              doShowFullScreenLoader={doShowFullScreenLoader}
            ></ContractMaintenance>
          </Modal.Body>
        </Modal>
      </div>

      <div>
        <Modal
          size="xl"
          centered
          show={isContractUpdatePopupOpen}
          onHide={() => {
            handleContractUpdatePopupClose();
          }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>Update Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <UpdateContract
              selectedRows={selectedRows}
              setUpdatedRowIds={setUpdatedRowIds}
              setDoShowFullScreenLoader={setDoShowFullScreenLoader}
              doShowFullScreenLoader={doShowFullScreenLoader}
              closeUpdateContract={handleContractUpdatePopupClose}
              updateGridCells={updateGridCells}
            />
          </Modal.Body>
        </Modal>
      </div>

      <div>
        <Modal
          size="xl"
          centered
          show={isContractRecallPopUpOpen}
          onHide={handleContractRecallClose}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>Recall Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContractRecall
              selectedRows={selectedRows}
              setUpdatedRowIds={setUpdatedRowIds}
              setDoShowFullScreenLoader={setDoShowFullScreenLoader}
              doShowFullScreenLoader={doShowFullScreenLoader}
              handleContractRecallClose={handleContractRecallClose}
              user={user}
              updateGridCells={updateGridCells}
            />
          </Modal.Body>
        </Modal>
      </div>

      <div>
        <Modal
          size="xl"
          centered
          show={isContractReturnPopUpOpen}
          onHide={handleContractReturnClose}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>Return Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContractReturn
              selectedRows={selectedRows}
              setDoShowFullScreenLoader={setDoShowFullScreenLoader}
              doShowFullScreenLoader={doShowFullScreenLoader}
              handleContractReturnClose={handleContractReturnClose}
              updateGridCells={updateGridCells}
              user={user}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default withUser(withRefreshBorrow(withRefreshLoan(Loan)));
